module.exports = __webpack_public_path__ + "img/PROTESIS_MAL_ESTADO.png";